// What a blacklist rule does when it matches (CP-8482), kept apart from the
// dialog so the validation and the wire shape are testable.
//
// - block: the delivery is blocked and, with redirect inboxes, emailed to them
//   instead (CP-8073). Every rule predating CP-8482 is a block rule.
// - cc: the delivery goes out as usual and up to MAX_CC_INBOXES addresses are
//   Cc'd on it. Email only. The backend Cc's guest recipients only, never staff.
import { MAX_CC_INBOXES, MAX_REDIRECT_INBOXES } from './constants';

const addresses = (value) => (value || '').split(',').map((a) => a.trim()).filter(Boolean);

/** The first problem with the form's action fields, or null. */
export const actionError = (form) => {
    if (form.action === 'cc') {
        if (form.delivery_type !== 'email') return 'Cc is only available for email rules.';
        const cc = addresses(form.cc_email);
        if (cc.length === 0) return 'Enter at least one Cc email address.';
        if (cc.length > MAX_CC_INBOXES) return `At most ${MAX_CC_INBOXES} Cc email addresses are allowed.`;
        return null;
    }
    if (addresses(form.redirect_to_email).length > MAX_REDIRECT_INBOXES) {
        return `At most ${MAX_REDIRECT_INBOXES} redirect email addresses are allowed.`;
    }
    if ((form.redirect_reply_to_email || '').includes(',')) {
        return 'Only one custom Reply-To email address is allowed.';
    }
    return null;
};

/**
 * The action part of the save payload. The fields the chosen action does not use
 * go out empty: the backend rejects a Cc rule that names redirect inboxes, and a
 * block rule that names Cc addresses.
 */
export const actionPayload = (form) => {
    const cc = form.action === 'cc';
    return {
        action: cc ? 'cc' : 'block',
        cc_email: cc ? addresses(form.cc_email).join(', ') || null : null,
        redirect_to_email: cc ? null : (form.redirect_to_email || '').trim() || null,
        redirect_reply_to_email: cc ? null : (form.redirect_reply_to_email || '').trim() || null,
        redirect_append_conversation_sid: form.redirect_append_conversation_sid,
    };
};
